import { z } from 'zod';
import type { ErrorPageType } from '~/constants';
import { BLOG_PATH, HOME_PATH, ORDERS_PATH, PRODUCTS_PATH, RETURNS_PATH, SHIPMENTS_PATH } from '~/constants';

/**
 * Map the error page type to the page URL. Used to send the user to the correct
 * page. Add more mappings as needed.
 */
const errorPageTypeToUrlMap = new Map<ErrorPageType, string>([
  ['article', BLOG_PATH],
  ['collection', PRODUCTS_PATH],
  ['order', ORDERS_PATH],
  ['page', HOME_PATH],
  ['product', PRODUCTS_PATH],
  ['return', RETURNS_PATH],
  ['shipment', SHIPMENTS_PATH],
]);

// Check if the page type is a valid error page type
export const isErrorPageType = (pageType: string): pageType is ErrorPageType => {
  return errorPageTypeToUrlMap.has(pageType as ErrorPageType);
};

// Get the error page URL based on the error page type
export const getErrorPageUrl = (pageType?: ErrorPageType): string => {
  return (pageType && errorPageTypeToUrlMap.get(pageType)) || HOME_PATH;
};

/**
 * An error can be a type of "DataWithResponseInit" when thrown from the
 * client-side.
 */
export const dataWithResponseInitSchema = z.object({
  data: z.string(),
  init: z
    .object({
      status: z.number(),
      statusText: z.string().optional(),
    })
    ?.nullable(),
  type: z.literal('DataWithResponseInit'),
});
